import { useContext, useEffect, useState } from "react";
import { CustomButton2, CustomModal } from "../../../../components";
import Context from "../../../../context";
import Row from "../../../../components/CustomView/Row";
import Column from "../../../../components/CustomView/Column";
import "./index.scss";
import CustomDropDownSearch from "../../../../components/CustomDropDownSearch";
import { IItem } from "../../../../types/common.interface";
import { ORDER_STATUS } from "../../../../values/dropdownItems";

const ChangeStatus = () => {
  const { setShowModal, showModal, selectedOrder, updateOrder, loading } =
    useContext(Context?.OrderScreen);
  const [status, setStatus] = useState<IItem>();

  const submitHandler = () => {
    updateOrder!({ status: status?._id, _id: selectedOrder?._id });
  };

  useEffect(() => {
    setStatus(ORDER_STATUS.find((item) => item._id === selectedOrder?.status));
  }, [selectedOrder]);
  return (
    <section id="order-detail-modal">
      <CustomModal
        onClose={() => setShowModal!("NONE")}
        open={showModal === "CHANGE_STATUS"}
        minWidth={"20rem"}
        maxWidth={"22rem"}
        minHeight={"10rem"}
      >
        <Row className="modal-user-info">
          <Column medium={12}>
            <CustomDropDownSearch
              items={ORDER_STATUS}
              itemName="name"
              onSelectItem={(event) => setStatus(event)}
              placeHolder="وضعیت سفارش"
              defaultItem={status}
            />
          </Column>
        </Row>
        <Row className="modal-user-info buttons-row">
          <Column medium={12}>
            <CustomButton2
              title={"ثبت وضعیت"}
              type="primary"
              onClick={submitHandler}
              isLoading={loading}
            />
          </Column>
        </Row>
      </CustomModal>
    </section>
  );
};

export default ChangeStatus;
